import React from 'react'
import { Loader, LoaderOverlay } from '@deque/cauldron-react'
import { useTranslation } from 'react-i18next'
import '@deque/cauldron-styles'
import './LoaderPage.scss'

export default function LoaderPage() {
  const { t } = useTranslation()
  return (
    <div className="LoaderPage">
      <LoaderOverlay role="alert">
        <Loader label={t('loading')} />
        <div>{t('loading')}</div>
      </LoaderOverlay>
    </div>
  )
}
